import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { goToTop } from '_helpers';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { colors } from '_styles';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const Container = styled.div`
  box-sizing: border-box;
  animation: ${OpacityAnimation} 0.7s;
  background-color: white;
  padding-bottom: 10px;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const Title = styled.h2`
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: bold !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px;
  padding-top: 13px;
  padding-left: 10px;
`;

const Description = styled.p`
  color: rgba(64, 64, 64, 1);
  font-size: 16px !important;
  line-height: 1.4em;
  font-weight: 500 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  -webkit-box-orient: vertical;
`;

const Button = styled.button`
  padding: 9px 12px;
  font-size: 13px !important;
  margin-left: auto;
  border-radius: 4px;
  font-weight: 500 !important;
  text-transform: capitalize;
  background-color: ${({ mainColor }) => (mainColor ? `#${mainColor}` : `${colors.LIGHT_BLUE}`)};
  color: white;
  margin-top: auto;
  text-decoration: none !important;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: all .3s;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    border: ${({ mainColor }) => (mainColor ? `1px solid #${mainColor}` : `1px solid ${colors.LIGHT_BLUE}`)};
    background-color: #fff;
    color: ${({ mainColor }) => (mainColor ? `#${mainColor}` : `${colors.LIGHT_BLUE}`)};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 4px 0px;
    opacity: 0.9;
  }
`;

const Wrapper = styled.div`
  display: flex;
  padding: 10px 20px 0px 10px;
  box-sizing: border-box;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100% !important;
`;

const RecycleRIGHTImage = styled.img`
  margin-left: auto !important;
  margin-right: 20px !important;
  height: 200px;
  object-fit: cover;
  object-position: 50% 50%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 4px 0px;
  width: 300px;
`;

const CustomEducationComponent = ({
  templateColors, title, description, image, button_target, button_label
}) => {
  const { main_color } = templateColors;

  return (
    <Container>
      <Title>
        {title}
      </Title>
      <Wrapper>
        <RecycleRIGHTImage
          src={image}
        />
        <RightContainer>
          <Description>
            {description}
          </Description>
          <Button
            mainColor={main_color || false}
            onClick={() => {
              window.open(button_target, '_blank');
              goToTop();
            }}
            aria-label={title}
          >
            {button_label}
          </Button>
        </RightContainer>
      </Wrapper>
    </Container>
  );
};

export default connect(
  (store) => ({
    templateColors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
  })
)(CustomEducationComponent);
